import { useTrackIsElementVisible } from '@src/quince-site-common/src/hooks/useTrackIsElementVisible'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'
import classnames from 'classnames'
import { useCallback, useMemo } from 'react'
import styles from './productOfferMessage.module.scss'
import { getTrackerAddedComboMessageOffer } from './utils'

export interface ProductOfferMessageProps {
  hideOfferMessage?: boolean
  offerMessageFromPC?: string
  productId?: number
  showFinalSaleMessage?: boolean
}

const ProductOfferMessage = (props: ProductOfferMessageProps) => {
  const { productId, offerMessageFromPC } = props
  const getIsVisibleTrackParams = useCallback(
    () => ({
      action: 'pdp_offer_message',
      value: true,
      context: {
        productId,
      },
    }),
    [productId],
  )
  const { ref: trackIsVisibleRef } = useTrackIsElementVisible(getIsVisibleTrackParams)

  const offerMessageWithTracker = useMemo(
    () => (offerMessageFromPC ? getTrackerAddedComboMessageOffer(offerMessageFromPC, productId) : offerMessageFromPC),
    [offerMessageFromPC, productId],
  )

  return (
    <>
      {!props.hideOfferMessage && offerMessageWithTracker && (
        <div
          className={classnames(styles.offermessage, styles.offermessage__offerMessageWithMto)}
          ref={trackIsVisibleRef}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: getSanitizedHtml(offerMessageWithTracker),
            }}
          ></div>
        </div>
      )}
    </>
  )
}

export default ProductOfferMessage
